import type { IRecord, IRecordTypeDefinition } from '@platform/core/types';
import { normalizeValue } from '../draftChanges';

/**
 * Значення копії запису («Дублювати», прототип createRecord з даними запису): усі поля типу, крім статусу (копія починає з
 * початкового), системних і файлових, з назвою «<назва> (копія)»; користувачі — ідентифікаторами, порожні значення пропускаються.
 * Чиста функція.
 */
export function duplicateValues(rt: IRecordTypeDefinition, record: IRecord, suffix: string): Record<string, unknown> {
  const values: Record<string, unknown> = { title: `${record.title}${suffix}` };
  for (const f of rt.fields) {
    if (f.key === 'title' || f.key === 'status' || f.system || f.type === 'file') continue;
    const v = normalizeValue(record.values[f.key]);
    if (v !== null) values[f.key] = v;
  }
  return values;
}
